import React from 'react';
import { BulletText } from 'imports/refundPolicy/ui/atoms';
import styled, { css } from 'styled-components';

const Bullet = (props) => {
  return (
    <BulletText isList={props.isList}>
      {!props.disableBullet && (
        <BulletWrapper>
          <BulletInner />
        </BulletWrapper>
      )}
      {props.children}
    </BulletText>
  );
};

export default Bullet;

const BulletWrapper = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  left: 0;
  top: 8px;
  background-color: rgba(81, 203, 255, 0.2);
  display: flex;
  ${({ theme: { isRTL } }) =>
    isRTL &&
    css`
      right: 0;
    `}
`;

const BulletInner = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin: auto;
  background-color: #0087c1;
`;
